import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Wrench } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { API } from '@/utils/api';

export const AtelierAccessCard = () => {
  const [cfg, setCfg] = useState(null);
  const [pin, setPin] = useState('');
  useEffect(() => {
    axios.get(`${API}/settings/atelier-access`).then(r => { setCfg(r.data); setPin(r.data.pin || ''); }).catch(() => setCfg(false));
  }, []);
  if (cfg === false || cfg === null) return null;

  const save = async () => {
    try { const r = await axios.put(`${API}/settings/atelier-access`, { pin }); setCfg(r.data); toast.success('Code atelier enregistré'); }
    catch (e) { toast.error(e.response?.data?.detail || 'Erreur'); }
  };

  return (
    <Card className="p-4 border-2 border-[#FACC15] flex flex-wrap items-center gap-4" data-testid="atelier-access-card">
      <div className="w-10 h-10 rounded-lg bg-[#0E1116] text-[#FACC15] flex items-center justify-center"><Wrench className="w-5 h-5" /></div>
      <div className="flex-1 min-w-[220px]">
        <p className="font-bold text-slate-900">Accès atelier (tablette / PC de l'atelier)</p>
        <p className="text-sm text-slate-600">Page <b>/atelier</b> · Code garage <b className="font-mono" data-testid="atelier-garage-code">{cfg.garage_code || '—'}</b>
          {!cfg.configured && <span className="text-red-600 font-semibold"> · aucun code PIN défini, l'atelier ne peut pas se connecter</span>}</p>
      </div>
      <Input value={pin} onChange={e => setPin(e.target.value.replace(/\D/g, '').slice(0, 4))} inputMode="numeric" placeholder="PIN 4 chiffres" className="w-36 font-mono text-center text-lg" data-testid="atelier-pin-input" />
      <Button onClick={save} disabled={pin.length !== 4} className="bg-[#0E1116] text-[#FACC15] hover:bg-black" data-testid="atelier-pin-save-btn">Enregistrer</Button>
    </Card>
  );
};
